export enum Section {
  ALL = 'all'
}
